import { isNull } from "@/utils/is";

const sessionCache = {
  set(key: strnull, value: strnull) {
    if (!sessionStorage) return;
    if (!isNull(key) && !isNull(value)) {
      sessionStorage.setItem(key, value);
    }
  },
  get(key: strnull) {
    if (!sessionStorage) return null;
    if (isNull(key)) return null;
    return sessionStorage.getItem(key);
  },
  remove(key: string) {
    sessionStorage.removeItem(key);
  },
};

const localCache = {
  set(key: strnull, value: strnull) {
    if (!localStorage) return;
    if (!isNull(key) && !isNull(value)) {
      localStorage.setItem(key, value);
    }
  },
  get(key: strnull) {
    if (!localStorage) return null;
    if (isNull(key)) return null;
    return localStorage.getItem(key);
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
};
export default {
  /**
   * 会话级缓存
   */
  session: sessionCache,
  /**
   * 本地缓存
   */
  local: localCache,
};
